module.exports = __webpack_public_path__ + "img/checklist_2_french.e09545fe.png";